// App.js or index.js
import React, { useMemo, useState } from 'react';
import { createTheme, ThemeProvider, CssBaseline, IconButton } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import PriceAlertComp from '../components/PriceAlertComp';
import PriceAlertCompBack from '../components/PriceAlertCompBack';
import PriceAlertRealtime from '../components/PriceAlertRealtime';

function PriceAlert() {
  const [mode, setMode] = useState('dark');

  const theme = useMemo(
    () => createTheme({ palette: { mode } }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ textAlign: 'right', padding: 16 }}>
        <IconButton onClick={() => setMode(prev => prev === 'light' ? 'dark' : 'light')}>
          {mode === 'light' ? <Brightness4 /> : <Brightness7 />}
        </IconButton>
      </div>
      <PriceAlertCompBack />
      {/* <PriceAlertComp /> */}
      {/* <PriceAlertRealtime /> */}
    </ThemeProvider>
  );
}

export default PriceAlert;
